import React from 'react';

const AppContext = React.createContext({ showModal: (title: string, message: string) => { }, showAfexModal: () => { }, showLoadingModal: () => { }, hideLoadingModal: () => { }, showForgotPasswordModal: () => { } });

export const AppProvider = AppContext.Provider;
export const AppConsumer = AppContext.Consumer;

export default AppContext;
